module.exports = __webpack_public_path__ + "img/bgtop1.3169f1db.jpg";